import React from 'react';
import { X, Trash2, AlertTriangle } from 'lucide-react';
import type { FeedbackWithUser } from '../../../services/feedbackService';

type AdminFeedbackDeleteModalProps = {
  feedback: FeedbackWithUser;
  onClose: () => void;
  onConfirm: () => void;
  deleting: boolean;
};

const AdminFeedbackDeleteModal: React.FC<AdminFeedbackDeleteModalProps> = ({
  onClose,
  onConfirm,
  deleting,
}) => (
  <div className="admin-feedback-delete-modal-overlay">
    <div className="admin-feedback-delete-modal">
      <div className="admin-feedback-delete-modal-header">
        <div className="admin-feedback-delete-modal-icon-wrap">
          <AlertTriangle className="w-6 h-6 text-red-400" />
        </div>
        <div className="admin-feedback-delete-modal-content">
          <h3 className="admin-feedback-delete-modal-title">Confirm Deletion</h3>
          <p className="admin-feedback-delete-modal-text">
            Are you sure you want to delete this feedback? This action cannot be undone.
          </p>
        </div>
        <button type="button" onClick={onClose} className="admin-feedback-delete-modal-close" aria-label="Close">
          <X className="w-5 h-5" />
        </button>
      </div>
      <div className="admin-feedback-delete-modal-actions">
        <button type="button" onClick={onClose} className="admin-feedback-delete-modal-cancel">
          Cancel
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={deleting}
          className="admin-feedback-delete-modal-confirm"
        >
          {deleting ? (
            <>
              <span className="admin-feedback-delete-modal-spinner" />
              <span>Deleting...</span>
            </>
          ) : (
            <>
              <Trash2 className="w-4 h-4" />
              <span>Delete</span>
            </>
          )}
        </button>
      </div>
    </div>
  </div>
);

export default AdminFeedbackDeleteModal;
